import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { SWRConfig } from 'swr';
import { Toaster } from 'sonner';
import App from './App';
import './styles/globals.css';

const fetcher = async (url: string) => {
  const res = await fetch(url, { credentials: 'include' });
  if (!res.ok) {
    const error = new Error('An error occurred while fetching the data.');
    throw error;
  }
  return res.json();
};

ReactDOM.createRoot(document.getElementById('root')!).render(
  <>
    <BrowserRouter>
      <SWRConfig
        value={{
          fetcher,
          revalidateOnFocus: false,
          revalidateOnReconnect: true,
          refreshInterval: 5 * 60 * 1000, // 5 minutes
          dedupingInterval: 10000, // 10 seconds
        }}
      >
        <App />
        <Toaster />
      </SWRConfig>
    </BrowserRouter>
  </>
);

